<template>
  <v-dialog persistent v-model="isShow" max-width="900px">
    <v-card>
      <v-flex xs10 offset-xs1 class="px-4 py-4">
        <p>Fields: Email, FirstName, LastName, Category, Package, JobTitle, Country, Company, PhoneNumber, WebSite, Gender.</p>
        <p>Accepted formats <strong>.csv/.xlsx</strong>. <a download href="/static/attendee-import-example.xlsx">download example</a></p>
        <div v-if="getModalUplodErrStatus">
          <h3 v-if="errorMessage"><strong>Check and fix these errors:</strong></h3>
          <div v-if="getErrorData.Code === 'fm.cms-0143'">
            <div
              v-for="(error, errorKey) in errorMessage"
              :key="`err-${errorKey}`"
              v-html="error"
            />
          </div>
          <div v-else-if="errorMessage">
            <span class="mb-0" v-html="errorMessage"/><br>
            <span class="mb-0" >Property name: {{ getErrorData.PropertyName }}</span>
          </div>
        </div>
      </v-flex>
      <v-flex class="pb-4 text-xs-center">
        <e-upload
          color="primary"
          :extensions="['.csv', '.xlsx']"
          :url="uploadUrl"
          method="post"
          padding="pb-0"
          :isShowErrorMessage="true"
        />
      </v-flex>
      <v-layout>
        <v-btn
          color="blue darken-1"
          flat="flat"
          @click="closeModal()"
        >
          Close
        </v-btn>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import EUpload from '@/components/shared/Upload'
  import { api } from '@/modules/api'
  import {
    SET_STATUS_VALIDATION_ERROR_MESSAGE,
    SET_VALIDATION_ERROR_MESSAGE,
    SET_CSV_FILE_UPLOAD_PROGRESS
  } from '@/store/mutation-types'

  export default {
    name: 'UploadWithExcel',
    components: {
      EUpload
    },
    props: {
      isShowModal: {
        type: Boolean,
        required: true
      }
    },
    data () {
      return {
        isShow: false,
        file: null,
        uploadUrl: api.massAttendeeActions.patchNewAttendeeViaExcel()
      }
    },
    watch: {
      isShow (val) {
        if (!val) this.$emit('close')
      }
    },
    computed: {
      ...mapGetters([
        'getErrorData',
        'getModalUplodErrStatus'
      ]),
      errorMessage() {
        if (!this.getModalUplodErrStatus || !this.getErrorData) return
        if (this.getModalUplodErrStatus && this.getErrorData.Code === 'fm.cms-0143') {
          return JSON.parse(this.getErrorData.ErrorMessage)
        } else {
          return this.getErrorData.Message
        }
      }
    },
    methods: {
      ...mapActions([
        'updateAttendeeViaExcel'
      ]),
      close () {
        this.$emit('close')
      },
      closeModal() {
        this.$store.commit(SET_STATUS_VALIDATION_ERROR_MESSAGE, false)
        this.$store.commit(SET_VALIDATION_ERROR_MESSAGE, {})
        this.$store.commit(SET_CSV_FILE_UPLOAD_PROGRESS, 0)
        this.$emit('closeModal')
        this.$emit('fetchAttendee')
      }
    },
    created () {
      this.isShow = this.isShowModal
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/shared/Upload/uploadNewWithExcel.vue